import axios from "axios";
import { Form, Formik } from "formik";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useGoogleLogin } from "@react-oauth/google";
import { TwButton, TwInputGroup, TwPhoneInputGroup } from "../../components/tailwind";
import FieldIcon from "../../components/tailwind/FieldIcons";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { getOnboardingRedirect, ONBOARDING_ROUTES, OWNER_BUSINESS_TYPE } from "../../utils/onboarding";

export default function SignUpForm(props) {
  const { navigation } = props;
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [userToken, setUserToken] = useLocalStorage("userToken", "");
  const userReduxState = useSelector(userState);

  const onLoginStart = useCallback(() => { }, []);

  const onSignUp = async (body, values = null, setSubmitting = () => { }) => {

    dispatch(setActionLoading(true));
    const request = await axios.post(
      `${getUrlForUsers()}registration`,
      body
    );
    dispatch(setActionLoading(false));
    setSubmitting(false);
    if (request.status === 200) {
      if (request.data.statusCode === 500 || request.data.statusCode === 403) {
        addErrorToast(request.data.message);
        return;
      }
      if (body.socialType !== "normal") {
        // addSuccessToast("Success!")

        let name = body.socialData.name;
        dispatch(userActions.setOnBoardingData(
          {
            sentFromSignupComplete: true,
            ...request.data.data,
            name: request.data.data.fullName,
          },
        ));
        dispatch(
          userActions.setUserData(request.data.data)
        );
        dispatch(
          userActions.setUserPhone("")
        );
        setUserToken(request.data.data.token);
        dispatch(userActions.setBusinessType(OWNER_BUSINESS_TYPE));
        /** Google sign-up (2026-10-28): the same onboarding as a phone sign-up (plan -> club details -> payouts).
         *  The account is already confirmed by Google, so there is no phone code step. */
        navigation(getOnboardingRedirect(request.data.data) || ONBOARDING_ROUTES.plan, {
          state: { from: "signup", clubName: "", name, socialType: body.socialType },
        });
      } else {
        // addSuccessToast("Success!")
        const onBordingData = {
          username: values.countryCode + "" + values.phone,
          // avatar: values.avatar,
          profilePic: values.profilePic,
          countryName: values.countryName,
          countryCode: values.countryCode,
          number: values.phone,
          phoneNumber: values.phone,
          formattedPhoneNumber: values.formattedPhoneNumber,
          // name: values.name,
          fullName: values.name,
          clubName: values.clubName?.trim() || "",
          password: values.password,
          response: request.data,
          socialType: body.socialType
        }
        // console.log("sign up onBordingData", onBordingData);

        dispatch(userActions.setOnBoardingData(onBordingData));
        navigation("/signup/verifynumber", {
          // navigation("/on-bording", {
          state: onBordingData,
        });
      }
    } else {
      addErrorToast("Oops, there seems to be a problem...");
    }
  }

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const userInfo = await axios.get(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } },
      );

      const body = {
        username: userInfo.data.email,
        // password: "",
        appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
        deviceType: "Web",
        userType: "teacher",
        socialType: 'google',
        socialToken: tokenResponse.access_token,
        socialData: {
          ...JSON.parse(JSON.stringify({
            ...userInfo.data,
            ...tokenResponse,
            provider: 'google',
          })),
        },
      };

      await onSignUp(body);
    },
    onError: errorResponse => console.log(errorResponse),
  });

  React.useEffect(() => {
    if (userToken !== undefined && userToken !== "" && userReduxState.userData?.fullName) {
      // navigation("/home/dashboard");
      window.location.href = "/home/dashboard";
    }
  }, []);

  return (
    <Formik
      initialValues={{
        profilePic:
          location.state !== null
            ? location.state.profilePic
            : "",
        // : avatar_placeholder_vector,
        countryName:
          location.state !== null ? location.state.countryName : "nl",
        countryCode: location.state !== null ? location.state?.countryCode || "+31" : "",
        phone: location.state !== null ? location.state.number : "",
        formattedPhoneNumber:
          location.state !== null ? location.state.formattedPhoneNumber : "",
        name: location.state !== null ? location.state.name || location.state.fullName || "" : "",
        clubName: location.state !== null ? location.state.clubName || "" : "",
        acceptTerms: false,
        password: location.state !== null ? location.state.password : "",
      }}
      // validateOnChange={false}
      // validateOnBlur={false}
      validate={(values) => {
        const errors = {};
        if (!values.phone) {
          errors.phone = "Required!";
        }

        if (!values.name) {
          errors.name = "Required!";
        }
        if (!values.clubName || !values.clubName.trim()) {
          errors.clubName = "Required!";
        }
        if (!values.acceptTerms) {
          errors.acceptTerms = "Please accept the terms to create your account.";
        }

        if (!values.password) {
          errors.password = "Required!";
        } else if (values.password.length < 8) {
          errors.password = "Must Contain 8 Characters";
        }
        return errors;
      }}
      onSubmit={async (values, { setSubmitting }) => {

        const body = {
          countryCode: values.countryCode,
          phoneNumber: values.phone,
          formattedPhoneNumber: values.formattedPhoneNumber,
          socialType: "normal",
          userType: "teacher",
        };
        await onSignUp(body, values, setSubmitting)

      }}
    >
      {({
        submitForm,
        isSubmitting,
        errors,
        setFieldValue,
        touched,
        values,
        handleBlur,
      }) =>
        !userToken ? (
          <Form>
            <div className={"flex flex-col gap-4"}>
              <button
                type="button"
                onClick={googleLogin}
                className="flex h-14 w-full items-center justify-center gap-3 rounded-2xl border-[1.5px] border-gray-300 bg-white text-base font-bold text-gray-900 transition hover:border-indigo-bz hover:bg-gray-50"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M22.6 12.3c0-.8-.1-1.5-.2-2.3H12v4.3h5.9a5 5 0 0 1-2.2 3.3v2.8h3.6c2.1-1.9 3.3-4.8 3.3-8.1z"></path><path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.7l-3.6-2.8c-1 .7-2.2 1.1-3.7 1.1-2.9 0-5.3-1.9-6.2-4.5H2.1v2.9A11 11 0 0 0 12 23z"></path><path fill="#FBBC05" d="M5.8 14.1a6.6 6.6 0 0 1 0-4.2V7H2.1a11 11 0 0 0 0 10l3.7-2.9z"></path><path fill="#EA4335" d="M12 5.4c1.6 0 3.1.6 4.2 1.7l3.2-3.2A11 11 0 0 0 2.1 7l3.7 2.9C6.7 7.3 9.1 5.4 12 5.4z"></path></svg>
                Continue with Google
              </button>

              <div className="my-2 flex items-center gap-3 text-sm font-semibold text-gray-500">
                <div className="h-px flex-1 bg-gray-200" />or sign up with your mobile<div className="h-px flex-1 bg-gray-200" />
              </div>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <TwInputGroup
                  label={"Your name"}
                  placeholder={"Full name"}
                  name={"name"}
                  leftIcon={<FieldIcon name="person" />}
                  value={values.name}
                  onChange={(e) => {
                    setFieldValue("name", e.target.value);
                  }}
                  errors={touched["name"] ? errors : {}}
                />
                <TwInputGroup
                  label={"Club name"}
                  placeholder={"e.g. Studio Noord"}
                  name={"clubName"}
                  leftIcon={<FieldIcon name="club" />}
                  value={values.clubName}
                  onChange={(e) => {
                    setFieldValue("clubName", e.target.value);
                  }}
                  errors={touched["clubName"] ? errors : {}}
                />
              </div>
              <TwPhoneInputGroup
                label={"Mobile number"}
                placeholder={"Mobile number"}
                name={"phone"}
                country={values.countryName}
                onBlur={() => handleBlur("phone")}
                onChange={(phone, country, e) => {
                  const numberWithoutDialCode = phone.split("");
                  for (let i = 0; i < country.dialCode.length; i++) {
                    numberWithoutDialCode.shift();
                  }
                  let dialCode = country.dialCode;
                  if (
                    country.format.includes("+") &&
                    !country.dialCode.includes("+")
                  ) {
                    dialCode = "+".concat(country.dialCode);
                  }
                  setFieldValue("countryName", country.countryCode);
                  setFieldValue("countryCode", dialCode);
                  setFieldValue("phone", numberWithoutDialCode.join(""));
                  setFieldValue("formattedPhoneNumber", e.target.value);
                }}
                helperText={"We'll text you a code to verify it's you."}
                errors={touched["phone"] ? errors : {}}
              />
              <TwInputGroup
                label={"Password"}
                placeholder={"At least 8 characters"}
                name={"password"}
                type={passwordVisible ? "text" : "password"}
                leftIcon={<FieldIcon name="lock" />}
                rightIcon={
                  <button type="button" aria-label={passwordVisible ? "Hide password" : "Show password"} onClick={() => setPasswordVisible(!passwordVisible)}>
                    {passwordVisible ? <EyeIcon className="size-5" /> : <EyeSlashIcon className="size-5" />}
                  </button>
                }
                onChange={(e) => {
                  setFieldValue("password", e.target.value);
                }}
                errors={touched["password"] ? errors : {}}
              />
              <div>
                <label htmlFor="acceptTerms" className="flex cursor-pointer items-start gap-3 text-sm text-gray-700">
                  <input
                    id="acceptTerms"
                    name="acceptTerms"
                    type="checkbox"
                    checked={values.acceptTerms}
                    onChange={(e) => setFieldValue("acceptTerms", e.target.checked)}
                    className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded border-gray-300 accent-[#7e00dd]"
                    aria-invalid={touched["acceptTerms"] && errors["acceptTerms"] ? "true" : "false"}
                  />
                  <span>
                    I agree to the{" "}
                    <a href="https://www.bookzyme.com/terms-and-conditions.html" target="_blank" rel="noreferrer" className="font-bold text-indigo-bz underline hover:text-indigo-bz-hover">Terms &amp; Conditions</a>
                    {" "}and{" "}
                    <a href="https://www.bookzyme.com/privacy-policy.html" target="_blank" rel="noreferrer" className="font-bold text-indigo-bz underline hover:text-indigo-bz-hover">Privacy Policy</a>
                  </span>
                </label>
                {touched["acceptTerms"] && errors["acceptTerms"] && (
                  <p className="mt-2 text-sm text-red-600" role="alert">{errors["acceptTerms"]}</p>
                )}
              </div>
              <TwButton
                onClick={submitForm}
                disabled={loadingReduxState.actionLoading || isSubmitting}
                actionLoading={(loadingReduxState.actionLoading)}
                className="fc-pulse mt-1 w-full !rounded-2xl !bg-brown-coffee py-3.5 text-base sm:text-lg font-extrabold hover:!bg-light-brown-coffee"
              >
                Create account
              </TwButton>
            </div>
          </Form>
        ) : ""
      }
    </Formik>
  );
}
